import { render } from "./RecipientInfo.vue?vue&type=template&id=70a34cb7"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\www_spf_delivery_thai\\@Developing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__